// https://netbasal.com/disabling-form-controls-when-working-with-reactive-forms-in-angular-549dd7b42110

import { Directive, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appDisableControl]',
  standalone: false
})
export class DisableControlDirective {
  @Input() set appDisableControl(condition: boolean) {
    if (this.ngControl && this.ngControl.control) {
      const action = condition ? 'disable' : 'enable';
      this.ngControl.control[action]();
    }
  }

  constructor(private ngControl: NgControl) {}
}
